// extracted by mini-css-extract-plugin
module.exports = {"resetButtonContainer":"SearchBox_resetButtonContainer_31T7W"};